// extracted by mini-css-extract-plugin
export default {"backdrop":"LazyLoader_backdrop__NT1r8","logo":"LazyLoader_logo__3Q-VP","blink":"LazyLoader_blink__bWhXq"};